module.exports = __webpack_public_path__ + "components/country-flag/static/sy-fe14fa1952acdabe368e5154c62d1d2d.svg";